import { gql } from '@apollo/client';

export const updateBankDetails = gql`
	mutation updateBankDetails(
		$bankName: String
		$accountName: String
		$accountNumber: String!
		$accountType: String
		$bankCode: String
		$branchName: String
		$swiftCode: String
		$bankAddress: String
		$beneficiaryName: String
		$beneficiaryAddress: String
	) {
		updateAccount(
			input: {
				bankName: $bankName
				accountName: $accountName
				accountNumber: $accountNumber
				accountType: $accountType
				bankCode: $bankCode
				branchName: $branchName
				swiftCode: $swiftCode
				bankAddress: $bankAddress
				beneficiaryName: $beneficiaryName
				beneficiaryAddress: $beneficiaryAddress
			}
		) {
			account {
				id
			}
			ok
			message
		}
	}
`;
